import dynamic from "next/dynamic";
// import { Props } from "./Props";

export const ContactWidgetLazy = dynamic(() => import("./ContactWidget").then(x => x.ContactWidget), {
  ssr: false
});
